import React, { Component } from "react";
import * as S from "./styles";
import { Toast } from "ratel-ui";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { doReportRequest } from "../../index";
import * as Latex from "../../../components/latex";
import VideoPlayer from "../videoPlayer";

class ModalAnswer extends Component {
  state = {
    resolutionIndex: 0,
    loading: true,
    loadingTooltip: false,
    reportToast: false,
    messageReport: "",
    questionText: "",
  };

  contentRef = React.createRef();

  reorderFeedback = (feedback) => {
    const mathFeedback = feedback
      .filter((it) => it.area === "5b2186ec9c5aa43084ff7d1c")
      .sort((a, b) => a.order - b.order);
    const restFeedback = feedback
      .filter((it) => it.area !== "5b2186ec9c5aa43084ff7d1c")
      .sort((a, b) => a.order - b.order);
    return [...restFeedback, ...mathFeedback];
  };

  componentDidMount() {
    const { resolutionIndex, feedbackQuestion } = this.props;
    if (resolutionIndex || resolutionIndex === 0) {
      this.setState(
        {
          resolutionIndex: resolutionIndex,
          questionText: feedbackQuestion,
          loading: true,
        },
        this.typesetContent,
      );
    }
  }

  // Tipografa o conteúdo do modal (já renderizado no DOM) e só desliga o
  // loading quando o MathJax termina — assim o usuário nunca vê o LaTeX cru
  // nem fórmulas a meio processar.
  typesetContent = () => {
    Latex.compile(
      () => this.setState({ loading: false }),
      this.contentRef.current,
    );
  };

  previusResolution = () => {
    const { resolutionIndex } = this.state;
    if (resolutionIndex > 0)
      this.setState(
        { resolutionIndex: resolutionIndex - 1, loading: true },
        this.typesetContent,
      );
  };

  nextResolution = () => {
    let { feedback } = this.props;
    feedback = this.reorderFeedback(feedback);
    const { resolutionIndex } = this.state;
    if (resolutionIndex < feedback.length - 1)
      this.setState(
        { resolutionIndex: resolutionIndex + 1, loading: true },
        this.typesetContent,
      );
  };

  sendReport = () => {
    const { messageReport, resolutionIndex } = this.state;
    this.setState({ loadingTooltip: true });
    let { simulated, doReportRequest, feedback } = this.props;
    feedback = this.reorderFeedback(feedback);
    const body = {
      question: {
        text: feedback[resolutionIndex].questionText,
        order: feedback[resolutionIndex].order,
        alternatives: [],
      },
      message: messageReport,
      simulated: simulated.id,
    };
    doReportRequest(body).then((response) => {
      if (response.error) {
        Toast.error("Não foi possível enviar a mensagem, tente novamente!");
      } else {
        Toast.success(
          "Mensagem enviada! Nossa equipe já recebeu e vai avaliar o problema!",
        );
      }
      this.setState({
        messageReport: "",
        reportToast: false,
        loadingTooltip: false,
      });
    });
  };

  render() {
    let { toggleModalAnswer, feedback = [], feedbackQuestion } = this.props;
    const { resolutionIndex, loading, reportToast, loadingTooltip } =
      this.state;
    feedback = this.reorderFeedback(feedback);

    const vimeoId =
      (feedbackQuestion.vimeoId ?? feedbackQuestion.vimeoID)?.trim() || null;
    const sambatechToken = feedbackQuestion.sambatech_token?.trim() || null;
    const youtubeUrl = feedbackQuestion.youtubeUrl?.trim() || null;

    const existsVideo = sambatechToken || vimeoId || youtubeUrl;

    const shouldShowVideo = feedbackQuestion && existsVideo;
    return (
      <S.Container>
        <S.Content className="modal modal-resolution-simulation is-active">
          <div
            className="modal-background"
            onClick={() => toggleModalAnswer(false)}
          />
          <div className="modal-card modal-resolution-simulation-card">
            <S.Header className="modal-card-head">
              <S.Title className="modal-card-title">
                Resolução - questão {resolutionIndex + 1}
              </S.Title>
            </S.Header>
            <section className="modal-resolution-simulation-body">
              <div
                className="modal-resolution-simulation-text"
                ref={this.contentRef}
              >
                <S.ResolutionContent loading={loading ? 1 : 0}>
                  <S.QuestionResolution>
                    <strong>Alternativa correta: </strong>
                    {feedbackQuestion.correctLetter}
                  </S.QuestionResolution>
                  <S.QuestionResolution>
                    <strong>Questão: </strong>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: feedbackQuestion.questionText,
                      }}
                    />
                  </S.QuestionResolution>
                  <S.QuestionResolution>
                    <strong>Resolução: </strong>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: feedbackQuestion.resolution,
                      }}
                    />
                  </S.QuestionResolution>
                  {shouldShowVideo ? (
                    <VideoPlayer
                      tokens={{
                        vimeo: vimeoId,
                        sambatech: sambatechToken,
                        youtube: youtubeUrl,
                      }}
                      player={feedbackQuestion.defaultPlayer}
                    />
                  ) : null}
                </S.ResolutionContent>
              </div>
              {loading && (
                <S.LoadingOverlay>
                  <S.Spinner />
                </S.LoadingOverlay>
              )}
            </section>
            <S.ButtonRow>
              <S.NewButton onClick={() => toggleModalAnswer(false)}>
                FECHAR
              </S.NewButton>
            </S.ButtonRow>

            {/* <div className="modal-resolution-simulation-footer">
              <div
                className={`modal-resolution-simulation-footer-button ${
                  resolutionIndex === 0 ? "disabled" : ""
                }`}
                onClick={this.previusResolution}
              >
                <Icon icon="back" width={16} height={16} />
              </div>
              <div
                className={`modal-resolution-simulation-footer-button ${
                  resolutionIndex === feedback.length - 1 ? "disabled" : ""
                }`}
                onClick={this.nextResolution}
              >
                <Icon icon="forward" width={16} height={16} />
              </div>
            </div> */}
          </div>
        </S.Content>
      </S.Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    simulated: state.simulation.data.simulation,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      doReportRequest,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalAnswer);
